import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router';
import ListFilter, { type FiltersChangeEvent } from '../../components/ui/ListFilter';
import RecordsList, { type SortItem } from '../../components/ui/RecordsList';
import { useUIStore } from '../../stores/ui/ui.store';
import { useCiudadesStore } from '../../stores/ciudades/ciudades.store';
import { fromSearchParams, listParamsToString, type ListParams } from '../common/list-params';

const columns = [
  { field: 'id', headerName: 'Código', width: 100, sortable: true },
  { field: 'nombre', headerName: 'Nombre', flex: 1, sortable: true }
];
const options = [
  { label: 'Código', value: 'codigo' },
  { label: 'Nombre', value: 'nombre' }
];

const ListaCiudades = () => {
  const [search, setSearch] = useSearchParams();
  const params = fromSearchParams(search);
  const [query, setQuery] = useState<ListParams>({
    ...params
  });
  const { pathname } = useLocation();
  const { list, cargarPaginadas } = useCiudadesStore((state) => state);
  const { loading } = useUIStore((state) => state);
  const addUrl = `${pathname}/agregar`;
  const editUrl = `${pathname}/editar`;

  const handleFiltersChange = ({ filterText, filterColumn, status }: FiltersChangeEvent) => {
    setQuery((x) => ({
      ...x,
      filtro: filterText,
      columna: filterColumn,
      status: status
    }));
  };
  const handlePageChange = (page: number) => {
    setQuery((x) => ({
      ...x,
      pagina: page
    }));
  };
  const handleSortChange = ({ field, sort }: SortItem) => {
    setQuery((x) => ({
      ...x,
      dir: sort,
      orden: field
    }));
  };

  useEffect(() => {
    cargarPaginadas({
      columnaFiltro: query.columna,
      columnaOrden: query.orden,
      direccionOrden: query.dir,
      filtro: query.filtro,
      pagina: query.pagina,
      limite: query.limite,
      status: query.status
    });
    setSearch(listParamsToString(query), { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return (
    <Grid container direction="column" spacing={2}>
      <Grid>
        <ListFilter
          module="ciudades"
          title="Ciudades"
          optionsFilter={options}
          canAdd={true}
          addUrl={addUrl}
          defaultFilterText={params.filtro}
          defaultFilterColumn={params.columna}
          defaultStatus={params.status}
          onFiltersChange={handleFiltersChange}
        />
      </Grid>
      <Grid>
        <RecordsList
          columns={columns}
          rows={list.items}
          page={list.pageIndex}
          pageSize={list.pageSize}
          rowCount={list.totalRows}
          loading={loading}
          canEdit={true}
          editUrl={editUrl}
          onPageChange={handlePageChange}
          onSortChange={handleSortChange}
        />
      </Grid>
    </Grid>
  );
};

export default ListaCiudades;
